<template>
    <div class="hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10">
        <div class="grid grid-rows-7 h-full">
            <MenuButton :to="{name:'Home'}" icon-class="icon-home" tooltip="Home"></MenuButton>
            <div class="flex-grow grid grid-rows-6 row-span-6">
                <MenuButton :to="{name:'ListaFornitori'}" icon-class="icon-catena_orizzontale" tooltip="Fornitori"></MenuButton>
                <MenuButton v-if="fid" :to="{name:'DettaglioFornitore', params: {fid}}" icon-class="icon-catena_verticale" tooltip="Fornitrore"></MenuButton>
                <MenuButton v-if="fid && hasPermission('approve fornitori')" :to="{name:'FornitoreAudit', params: {fid}}" icon-class="icon-orologio_freccia" tooltip="Modifiche"></MenuButton>
<!--                <MenuButton :to="{name:'ListaPianoDiFatturazione', params: {id}}" icon-class="icon-euro_frecce" tooltip="Piano di fatturazione"></MenuButton>-->
<!--                <MenuButton v-if="$route.meta.showSottoprogetti" :to="{name:'SottoProgettoListaFornitori', params: {id}}" icon-class="icon-documento_freccia" tooltip="Fornitori"></MenuButton>-->
<!--                <MenuButton v-if="$route.meta.showSottoprogetti" :to="{name:'ListaOrdini', params: {id}}" icon-class="icon-carrello" tooltip="Ordini"></MenuButton>-->
<!--                <MenuButton v-if="$route.meta.showSottoprogetti" :to="{name:'ListaOrdini', params: {id}}" icon-class="icon-browser" tooltip="Ordini"></MenuButton>-->
<!--                <ProfileMenuButton class="row-start-6" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>-->
                <ProfileMenuButton class="row-start-6" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>
            </div>
        </div>
    </div>

<!--    <div v-if="$store.state.menu_visible" class="md:hidden fixed z-10 inset-0 bg-gray-500 bg-opacity-90"-->
<!--         @click="toggle">-->
<!--        <div class="flex flex-col text-white text-4xl pl-12 pt-14">-->
<!--            <div class="py-4">-->
<!--                <i class="self-center text-md icon-home"></i>-->
<!--                <router-link :to="{name:'Dashboard'}" class="pl-4">HOME</router-link>-->
<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <i class="self-center text-2xl fas fa-ellipsis-h"></i>-->
<!--                <router-link :to="{name:'ListaProgetti'}" class="pl-4">Progetti</router-link>-->
<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <i class="self-center text-2xl icon-opzioni"></i>-->
<!--                <router-link :to="{name:'ListaSottoProgetti'}" href="#" class="pl-4">Sottoprogetti</router-link>-->
<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <i class="self-center text-2xl fas fa-file-export"></i>-->
<!--                <router-link :to="{name:'ListaBudget'}" href="#" class="pl-4">Budget</router-link>-->
<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <i class="self-center text-2xl fas fa-shopping-cart"></i>-->
<!--                <router-link :to="{name:'ListaOrdini'}" href="#" class="pl-4">Ordini</router-link>-->
<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <i class="self-center text-2xl far fa-credit-card"></i>-->
<!--                <a href="#" class="pl-4">boh</a>-->
<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <i class="self-center fa fa-circle text-md"></i>-->
<!--                <router-link :to="{name:'ProfiloUtente'}" class="pl-4">PROFILO</router-link>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import MenuButton from "@/components/MenuButton.vue";
import ProfileMenuButton from "@/components/ProfileMenuButton.vue";
import { mapGetters } from 'vuex';

@Options({
    name:'FornitoriMenu',
    components:{
        MenuButton,
        ProfileMenuButton
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        fid: {
            type: [Number,String],
            required: false,
            default: 0
        },
    },
    computed: {
        ...mapGetters([
            'meCounters',
            'hasPermission',
        ]),
    },
})
export default class FornitoriMenu extends Vue {
    private $store: any;
    fid!: any;

    toggle() {
        this.$store.commit('toggle_menu')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
